import React from "react";
import { Badge, Form, Modal } from "react-bootstrap";

const UpdateQueryFunctionModal = ({
  Show,
  Hide,
  setFunctions,
  functions,
  setQuery,
  setQueryId,
  queryId,
  query,
}) => {
  const updateQueryParameter = (functions) => {
    const updatedQuery = query?.map(item => {
      if (item.id === queryId) {
        return {
          ...item,
          value: functions || ""
        };
      }
      return item;
    });
    setQuery(updatedQuery);
    setFunctions("")
    setQueryId("")
    Hide()
  };
  return (
    <>
      <Modal show={Show} onHide={Hide} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>
            Replace Function
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Function{" "}
              <abbr title="required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <div className="hstack gap-2 flex-wrap">
              <Badge onClick={() => setFunctions("DAY")} className="br3 text-dark CP" bg={functions === "DAY" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Day Function">Day</Badge>
              <Badge onClick={() => setFunctions("MONTH")} className="br3 text-dark CP" bg={functions === "MONTH" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Month Function">Month</Badge>
              <Badge onClick={() => setFunctions("YEAR")} className="br3 text-dark CP" bg={functions === "YEAR" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Year Function">Year</Badge>
              <Badge onClick={() => setFunctions("MIN")} className="br3 text-dark CP" bg={functions === "MIN" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Min Function">Min</Badge>
              <Badge onClick={() => setFunctions("MAX")} className="br3 text-dark CP" bg={functions === "MAX" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Max Function">Max</Badge>
              <Badge onClick={() => setFunctions("MEAN")} className="br3 text-dark CP" bg={functions === "MEAN" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Mean Function">Mean</Badge>
              <Badge onClick={() => setFunctions("MEDIAN")} className="br3 text-dark CP" bg={functions === "MEDIAN" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Median Function">Median</Badge>
              <Badge onClick={() => setFunctions("ROUND")} className="br3 text-dark CP" bg={functions === "ROUND" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Round Function">Round</Badge>
              <Badge onClick={() => setFunctions("SUM")} className="br3 text-dark CP" bg={functions === "SUM" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Sum Function">Sum</Badge>
              <Badge onClick={() => setFunctions("GEOMETRICMEAN")} className="br3 text-dark CP" bg={functions === "GEOMETRICMEAN" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Geo Metric Mean Function">Geo Metric Mean</Badge>
              <Badge onClick={() => setFunctions("STD")} className="br3 text-dark CP" bg={functions === "STD" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="STD Function">STD</Badge>
              <Badge onClick={() => setFunctions("CV")} className="br3 text-dark CP" bg={functions === "CV" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="CV Function">CV</Badge>
              <Badge onClick={() => setFunctions("SUBSTRING")} className="br3 text-dark CP" bg={functions === "SUBSTRING" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Sub-String Function">Sub-String</Badge>
              <Badge onClick={() => setFunctions("COUNTCHAR")} className="br3 text-dark CP" bg={functions === "COUNTCHAR" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Count Characters Function">Count Characters</Badge>
              <Badge onClick={() => setFunctions("COUNTWORD")} className="br3 text-dark CP" bg={functions === "COUNTWORD" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Count Words Function">Count Words</Badge>
              <Badge onClick={() => setFunctions("LENGTH")} className="br3 text-dark CP" bg={functions === "LENGTH" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Length Function">Length</Badge>
              <Badge onClick={() => setFunctions("STRIP")} className="br3 text-dark CP" bg={functions === "STRIP" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Strip Function">Strip</Badge>
              <Badge onClick={() => setFunctions("UPPERCASE")} className="br3 text-dark CP" bg={functions === "UPPERCASE" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Uppercase Function">Uppercase</Badge>
              <Badge onClick={() => setFunctions("LOWERCASE")} className="br3 text-dark CP" bg={functions === "LOWERCASE" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Lowercase Function">Lowercase</Badge>
              <Badge onClick={() => setFunctions("CAPITALIZE")} className="br3 text-dark CP" bg={functions === "CAPITALIZE" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Capitalize Function">Capitalize</Badge>
              <Badge onClick={() => setFunctions("REPLACE")} className="br3 text-dark CP" bg={functions === "REPLACE" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Replace Function">Replace</Badge>
              <Badge onClick={() => setFunctions("TRIMSPACE")} className="br3 text-dark CP" bg={functions === "TRIMSPACE" ? "purple text-white" : "purple-subtle"} style={{ fontSize: 12 }} title="Trip Space Function">Trip Space</Badge>
            </div>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="p-1 px-3 bg-gold">
          <button
            className="updateProfile"
            style={{ fontSize: 12 }}
            disabled={!functions}
            onClick={() => updateQueryParameter(functions)}
          >
            Replace
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UpdateQueryFunctionModal;
